import { Opportunity } from '../general';

function sortBoolean(
    a: boolean,
    b: boolean,
    direction: 'asc' | 'desc',
): number {
    let valA = Number.MIN_SAFE_INTEGER;
    let valB = Number.MIN_SAFE_INTEGER;
    if (a != null) {
        valA = a === true ? 1 : 2;
    }
    if (b != null) {
        valB = b === true ? 1 : 2;
    }

    const result = direction === 'asc' ? valA - valB : valB - valA;
    return result === 0 ? null : result;
}

function sortNumber(a: number, b: number, direction: 'asc' | 'desc'): number {
    const valA = a == null ? Number.MIN_SAFE_INTEGER : a;
    const valB = b == null ? Number.MIN_SAFE_INTEGER : b;
    const result = direction === 'asc' ? valA - valB : valB - valA;
    return result === 0 ? null : result;
}

function sortString(a: string, b: string, direction: 'asc' | 'desc'): number {
    const valA = a || '';
    const valB = b || '';
    const result =
        direction === 'asc'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
    return result === 0 ? null : result;
}

export function sortOpportunities(
    a: Opportunity,
    b: Opportunity,
    direction: 'asc' | 'desc',
): number {
    let result;

    result = sortBoolean(a.isOppActive, b.isOppActive, direction);
    if (result != null) {
        return result;
    }

    result = sortNumber(a.rankScore, b.rankScore, direction);
    if (result != null) {
        return result;
    }

    result = sortNumber(a.percentToTarget, b.percentToTarget, direction);
    if (result != null) {
        return result;
    }

    result = sortString(a.metricShortName, b.metricShortName, direction);
    if (result != null) {
        return result;
    }

    return 0;
}
